import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function AcceptInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");

  useEffect(() => {
    api.get(`/auth/invite/${token}`).then((r) => { setInvite(r.data); setName(r.data.name || ""); }).catch((e) => setError(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords do not match");
    try {
      await api.post("/auth/invite/accept", { token, password: pw, name });
      toast.success("Account created. Sign in and set up MFA.");
      nav("/login");
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background bg-grid p-6">
      <div className="w-full max-w-sm rounded-md border bg-card p-6 fade-up">
        <div className="label">Private invitation</div>
        <h1 className="mt-2 font-display text-3xl font-bold uppercase">Join NEXUS Trade Command</h1>
        {error && <p className="mt-4 text-sm text-down" data-testid="invite-error">{error}</p>}
        {invite && (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="invite-accept-form">
            <div className="space-y-1"><Label className="label">Email</Label><div className="font-mono text-sm" data-testid="invite-email">{invite.email}</div></div>
            <div className="space-y-2"><Label className="label">Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="invite-name-input" /></div>
            <div className="space-y-2"><Label className="label">Password (min 10 chars)</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} minLength={10} required data-testid="invite-password-input" /></div>
            <div className="space-y-2"><Label className="label">Confirm password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="invite-password-confirm-input" /></div>
            <Button type="submit" className="w-full" data-testid="invite-accept-submit-button">Create account</Button>
          </form>
        )}
      </div>
    </div>
  );
}
